/**
 * Converts an image URL to base64 using canvas
 * @param {string} imageUrl - The URL of the image to convert
 * @returns {Promise<string>} - Promise that resolves to base64 data URL
 */
export const fetchAndConvertToBase64 = async (imageUrl) => {
  return new Promise((resolve, reject) => {
    try {
      // Use Image object instead of fetch to avoid CORS issues
      const img = new Image();

      // Set up load and error handlers before setting src
      img.onload = () => {
        // Create canvas to draw the image
        const canvas = document.createElement("canvas");
        canvas.width = img.width;
        canvas.height = img.height;

        // Draw image to canvas
        const ctx = canvas.getContext("2d");
        ctx.drawImage(img, 0, 0);

        // Convert canvas to base64
        try {
          const dataUrl = canvas.toDataURL("image/png");
          resolve(dataUrl);
        } catch (canvasError) {
          console.error("Error converting canvas to base64:", canvasError);
          reject(canvasError);
        }
      };

      img.onerror = () => {
        console.error("Failed to load image:", imageUrl);
        reject(new Error("Failed to load image"));
      };

      // Set crossOrigin to anonymous to prevent tainted canvas
      img.crossOrigin = "anonymous";

      // Set src to trigger loading - add cache buster to avoid cached non-CORS responses
      img.src = `${imageUrl}?${new Date().getTime()}`;
    } catch (error) {
      console.error("Error loading or converting image to base64:", error);
      reject(error);
    }
  });
};
